import { Step } from "react-joyride";

export const tourStepsGames = (): Step[] => {
  const steps: Step[] = [
    {
      target: "h1.mb-8",
      content:
        "Games are extra practice modes. They use your collections or custom word lists. Open one from this list.",
      disableBeacon: true,
    },
    {
      target: ".games-intro",
      content:
        "Each game has a setup screen first. You can always use Back to Games to return here.",
    },
    {
      target: ".matching-game",
      content:
        "Matching Game: add words, then drag to connect each word to its match. You can use a timer or play with no time limit.",
    },
    {
      target: ".multiple-words-game",
      content:
        "Multiple Words: add related pairs such as Furniture and Couch, then match the left column to the right.",
    },
    {
      target: ".timed-challenges-game",
      content:
        "Timed Challenges: pick a collection and see how many items you can identify in 60 seconds.",
    },
    {
      target: ".typing-simulator-game",
      content:
        "Typing Simulator: a passage appears on screen. Type it as you go to practice accuracy and speed.",
    },
    {
      target: ".missing-number-game",
      content:
        "Missing Number: fill in the blank in a sequence, like 1, 2, __, 4. You can use presets or make your own.",
    },
    {
      target: ".timed-trials-game",
      content:
        "Timed Trials: take turns racing through a collection. Times are saved on a leaderboard for that collection.",
    },
    {
      target: ".multiple-choice-game",
      content:
        "Multiple Choice: write questions and answers, then click a colored button. Answer positions shuffle each time.",
    },
    {
      target: ".quiz-show-game",
      content:
        "Quiz Show: put the question on the projector. Students join on phones with a room code and tap an answer.",
    },
  ];

  return steps;
};
